import React from 'react'
import { Box, Stack } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { K1Generic } from '@e3dc-react/icons'
import { getCurrencyValue } from '../../shared/utils/currency-value'

const useStyles = makeStyles()(theme => ({
  iconWrapper: {
    marginLeft: theme.spacing(1.5),
  },
}))

interface Props {
  chargePrice: number
  currencyCode: string
}

/**
 * Charge price is always displayed with additional information icon and tooltip next to it,
 * further explaining that it is an "estimation" or "average" price throughout the charging because
 * the cost calculation is much more complex(taking new values every "x" seconds and applying currently
 * active grid and solar price to the new energy diff).
 */
export const ChargePriceCell: React.FC<Props> = ({ chargePrice, currencyCode }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <Stack direction="row">
      <Box alignSelf="center">{getCurrencyValue(chargePrice, currencyCode)}</Box>
      <Box alignSelf="center" className={classes.iconWrapper}>
        <OptionalTooltipWrapper placement="top" titleKey={t('emobility.chargingSession.charge-price-value-tooltip-info')}>
          <K1Generic />
        </OptionalTooltipWrapper>
      </Box>
    </Stack>
  )
}
